<template>
    <div class="leftContent">
        <div class="search">
            <el-input type="text" style="width:200px" :placeholder="$t('param.param_content_name_placeholder')" v-model="listQuery.name" clearable></el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
            <el-button type="primary" icon="el-icon-plus" class="btnClass" @click="typeAdd"></el-button>
        </div>
        <div class="content" ref="rightDiv">
            <ul v-if="letContent.length > 0">
                <li v-for="(item, index) in letContent" :key="item.id" :class="active === index ? 'active' : ''" @click="handleClick(item, index)">
                    <span>{{ item['name'] }}</span>
                    <span>
                        <i class="el-icon-edit" @click="editFn(item)"></i>
                        <i class="el-icon-delete" @click="deleteFn(item, index)"></i>
                    </span>
                </li>
                <div class="moreLoad">
                    <i class="el-icon-loading" v-show="loading"></i>
                    <span v-show="flagText && !loading">{{ $t('public.no_more') }}</span>
                </div>
            </ul>
            <el-empty v-else :description="$t('public.no_data')"></el-empty>
        </div>
        <!-- 弹出框 -->
        <Dialog :isShow.sync="isShow" :title="title" :formRow="formRow" :optareStatus="optareStatus" ref="diaLog" />
    </div>
</template>

<script>
import { paramList, paramContentDel } from '@/api/modules/params.js';
import Dialog from './Dialog.vue';
import bus from '@/utils/bus.js';
export default {
    components: {
        Dialog
    },
    data() {
        return {
            letContent: [],
            listQuery: {
                iDisplayStart: 0,
                iDisplayLength: 50,
                name: null
            },
            loading: false,
            total: '',
            // 默认选择
            active: 0,
            // no more
            flagText: false,
            // 右侧第一条数据
            rightObj: null,
            // 弹窗框
            isShow: false,
            title: '',
            optareStatus: '',
            formRow: {}
        };
    },
    created() {
        this.getList();
    },
    mounted() {
        this.$nextTick(() => {
            // 一定要加这个true  否则滚动无效
            window.addEventListener('scroll', this.handleScroll, true);
        });
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll, true);
    },

    methods: {
        searchTree() {
            (this.listQuery.iDisplayStart = 0), (this.listQuery.iDisplayLength = 50), (this.letContent = []);
            this.getList();
        },
        typeAdd() {
            this.isShow = true;
            this.optareStatus = 'add';
            this.title = this.$t('param.title_add_param_type');
            (this.formRow = {}),
                this.$nextTick(() => {
                    this.$refs['diaLog'].clearValidate();
                });
        },
        handleScroll(e) {
            //滚动的像素+容器的高度>可滚动的总高度-20像素
            const scrollTop = this.$refs.rightDiv.scrollTop;
            // 获取可视区的高度
            const windowHeight = this.$refs.rightDiv.clientHeight;
            // 获取滚动条的总高度
            const scrollHeight = this.$refs.rightDiv.scrollHeight;

            if (scrollTop + windowHeight >= scrollHeight) {
                // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
                // 调用函数
                this.listQuery.iDisplayStart += 50;
                this.listQuery.iDisplayLength = 50;
                this.loading = true;
                // 这里也可以使用总数  感觉总数好点
                if (this.flagText) return (this.loading = false);
                // if (this.total<=this.letContent.length) return this.loading = false,this.flagText = true;
                this.loading = true;
                this.getList();
            }
        },
        getList() {
            // this.loading = true;
            paramList(this.listQuery)
                .then(({ result, pageInfo }) => {
                    if (result.length === 0) this.flagText = true;
                    // this.total = pageInfo.total
                    this.letContent = this.letContent.concat(result);

                    if (!this.rightObj) {
                        this.rightObj = { ...this.letContent[0] };
                        bus.$emit('leftContentFn', this.rightObj);
                    } else {
                        bus.$emit('leftContentFn', this.letContent[this.active]);
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 100);
                });
        },
        handleClick(item, index) {
            this.active = index;
            this.rightObj = { ...item };
            bus.$emit('leftContentFn', this.rightObj);
        },
        //编辑
        editFn(item) {
            this.isShow = true;
            this.$nextTick(() => {
                this.$refs['diaLog'].clearValidate();
                this.title = this.$t('public.tbopt_edit') + `[${item.name}]`;

                this.formRow = { ...item };
                this.optareStatus = 'edit';
            });
        },
        // 删除
        deleteFn(item, index) {
            this.$confirm(this.$t('public.btn_confirm'), this.$t('public.btn_cancel'), {
                confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
                cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
                type: 'warning'
            })
                .then(() => {
                    paramContentDel({ ids: item.id }).then(({ result, state }) => {
                        if (result === 1) {
                            this.$message.success($t('integration.successfully_deleted'));
                            // this.letContent.splice(index, 1);
                            // bus.$emit('leftContentFn', this.letContent[0]);
                            this.letContent = [];
                            this.listQuery.iDisplayStart = 0;
                            this.listQuery.iDisplayLength = 50;
                            this.active = 0;
                            this.rightObj = null;
                            this.getList();
                        } else if (result === 2) {
                            this.$message.error(this.$t('public.system_error'));
                        } else if (result === 0) {
                            this.$message.error(this.$t('param.tip_del_fail'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.leftContent {
    width: 300px;
    border-right: 1px solid #ccc;
    box-sizing: border-box;
    .search {
        width: 100%;
        height: 40px;
        margin: 0 0 5px 0;
        padding-left: 10px;
        border-bottom: 1px solid $borderColor3;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        ::v-deep .el-icon-plus {
            color: #fff !important;
        }
    }
    .content {
        height: calc(100% - 45px);
        overflow: auto;
        box-sizing: border-box;
        li {
            display: flex;
            padding: 0 10px;
            margin: 0 10px 5px 10px;
            height: 40px;
            border: 1px solid #ccc;
            box-sizing: border-box;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            border-radius: 2px;
            i {
                cursor: pointer;
                margin-right: 5px;
                color: #ccc;
                &:hover {
                    color: var(--primary-color);
                }
            }
        }
        .active {
            background-color: var(--primary-color);
            color: #fff;
        }
    }
    .moreLoad {
        text-align: center;
        font-size: 22px;
        line-height: 30px;
        // background-color: var(--primary-color);
    }
}
</style>
